import script from "./QuestReveal.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestReveal.vue?vue&type=script&setup=true&lang=js"

import "./QuestReveal.vue?vue&type=style&index=0&id=dd4e2480&scoped=true&lang=css"
import "./QuestReveal.vue?vue&type=style&index=1&id=dd4e2480&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd4e2480"]])

export default __exports__